export default {
    url: '/list',
    template: `
        <forms-validations-list
            sites="vm.sites"
            trainers="vm.trainers"
        />
    `,
    resolve: {
        sites (SiteResource) {
            return SiteResource.query({ formSites: true, validationsSites: true }).$promise;
        },
        trainers (UserResource, ROLE_CODE_ENUM, PrivilegeService, TokenService) {
            return PrivilegeService.isCompanyAdmin() ?
            UserResource.query({ roleCode: ROLE_CODE_ENUM.KEYS.TRAINER, pageSize: 0 }).$promise :
            UserResource.query({ 'ids[]': [TokenService.getUser().id] }).$promise;
        }
    },
    controller (sites, trainers) {
        this.sites = sites;
        this.trainers = trainers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/validations/list/index.js